(() => {
  /* BEZELOR options sheet: instant colour switching and swipe-down to close.
     1. The theme's fast path (no server round trip) only handled products with a single option.
        Most watches also carry a one-value option such as "Ships From", so every tap waited for the
        server: the Add to cart button greyed out and the sheet redrew. This lets the fast path match
        any combination of options (templates rendered in snippets/product-variant-picker.liquid).
     2. Drag the sheet down to close it. */

  /* ---------- 1. Instant variant switching ---------- */
  const patch = () => {
    const ProductInfo = customElements.get('product-info');
    if (!ProductInfo || ProductInfo.prototype.__bzFastAny) return;
    ProductInfo.prototype.__bzFastAny = true;
    ProductInfo.prototype.applyPanelVariant = function (target, selectedOptionValues) {
      if (this.dataset.variantPanelReady !== 'true' || !selectedOptionValues || !selectedOptionValues.length) return false;
      if (target.dataset.productUrl && target.dataset.productUrl !== this.dataset.url) return false;
      if (this.querySelector('[id^="Inventory-"]')) return false;
      const key = selectedOptionValues.join(',');
      const state = this.variantSelectors?.querySelector('template[data-bezelor-fast-variant="' + CSS.escape(key) + '"]');
      if (!state) return false;
      const variant = this.parseJsonScript(state.content, 'script');
      if (!variant) return false;
      const rule = variant.quantity_rule;
      if (rule && (rule.min !== 1 || rule.increment !== 1 || rule.max != null)) return false;
      if (this.productForm?.submitButton.classList.contains('loading')) return false;
      this.abortController?.abort();
      this.pendingRequestUrl = null;
      this.productForm?.handleErrorMessage();
      const price = this.querySelector('[id="price-' + this.dataset.section + '"]');
      const fastPrice = state.content.querySelector('[data-fast-price]');
      if (price && fastPrice) {
        price.innerHTML = fastPrice.innerHTML;
        price.classList.remove('hidden');
      }
      const sku = this.querySelector('[id="Sku-' + this.dataset.section + '"] .sku');
      if (sku) sku.textContent = variant.sku || '';
      const selected = this.variantSelectors.querySelector('[data-selected-variant]');
      if (selected) selected.textContent = JSON.stringify(variant);
      this.variantSelectors.dataset.selectedPriceAmount = (variant.price / 100).toFixed(2);
      this.variantSelectors.resolvePendingSelectPromise?.(variant);
      this.updateVariantInputs(variant.id);
      this.pickupAvailability?.update(variant);
      this.updateURL(this.dataset.url, variant.id);
      this.productForm?.toggleSubmitButton(!variant.available, window.variantStrings.soldOut);
      const html = new DOMParser().parseFromString(this.outerHTML, 'text/html');
      publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: this.sectionId, html, variant } });
      return true;
    };
  };
  if (window.customElements) customElements.whenDefined('product-info').then(patch);

  /* ---------- 2. Swipe the sheet down to close ---------- */
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let sheet = null;
  let startY = 0;
  let startX = 0;
  let lastY = 0;
  let lastT = 0;
  let speed = 0;
  let dragging = false;
  let decided = false;

  const reset = (dialog) => {
    dialog.style.transition = '';
    dialog.style.translate = '';
    dialog.classList.remove('bz-sheet-dragging');
  };

  document.addEventListener('touchstart', (event) => {
    const dialog = event.target.closest && event.target.closest('dialog.bezelor-variant-panel[open]');
    if (!dialog || event.touches.length !== 1) return;
    const body = dialog.querySelector('.bezelor-panel-body');
    /* Only when the sheet's content is scrolled to the top, and not on the button row */
    if ((body && body.scrollTop > 2 && body.contains(event.target)) || event.target.closest('.bezelor-panel-actions')) return;
    sheet = dialog;
    startY = lastY = event.touches[0].clientY;
    startX = event.touches[0].clientX;
    lastT = performance.now();
    speed = 0;
    dragging = false;
    decided = false;
  }, { passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!sheet) return;
    const y = event.touches[0].clientY;
    const dy = y - startY;
    const dx = event.touches[0].clientX - startX;
    if (!decided) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      decided = true;
      /* Sideways (the colour row) or upwards: leave it to the page */
      if (Math.abs(dx) > Math.abs(dy) || dy < 0) {
        sheet = null;
        return;
      }
      dragging = true;
      sheet.classList.add('bz-sheet-dragging');
      sheet.style.transition = 'none';
    }
    if (!dragging) return;
    event.preventDefault();
    const now = performance.now();
    speed = (y - lastY) / Math.max(1, now - lastT);
    lastY = y;
    lastT = now;
    sheet.style.translate = '0 ' + Math.max(0, dy) + 'px';
  }, { passive: false });

  const end = () => {
    if (!sheet) return;
    const dialog = sheet;
    sheet = null;
    if (!dragging) return;
    dragging = false;
    const dy = lastY - startY;
    const height = dialog.getBoundingClientRect().height;
    if (dy > Math.min(140, height * 0.28) || speed > 0.6) {
      /* Slide the rest of the way down, then close */
      dialog.style.transition = reduce.matches ? 'none' : 'translate 0.22s cubic-bezier(0.4, 0, 1, 1)';
      dialog.style.translate = '0 ' + (height + 40) + 'px';
      setTimeout(() => {
        if (dialog.open) dialog.close();
        reset(dialog);
      }, reduce.matches ? 0 : 220);
    } else {
      /* Spring back */
      dialog.style.transition = 'translate 0.35s cubic-bezier(0.2, 0.9, 0.25, 1.2)';
      dialog.style.translate = '0 0';
      setTimeout(() => reset(dialog), 360);
    }
  };
  document.addEventListener('touchend', end, { passive: true });
  document.addEventListener('touchcancel', end, { passive: true });
})();
